// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#mathfield[data-v-29554b8c] math-field{width:100%;position:relative;font-size:24px;border:0 solid transparent;z-index:1;padding:8px}@media not (pointer:coarse){math-field[data-v-29554b8c]::part(virtual-keyboard-toggle){display:none}math-field[data-v-29554b8c]::part(menu-toggle){display:none}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
